/** @format */

import React, { useState, useEffect } from 'react';
import ContentParser from 'src/ui/library/ContentParser';
import { transformFormValues } from 'src/helpers/';
import Result from './showOrganizerResponse.json';

export default function TestParser() {
  const [mockTextArea, setMockTextArea] = useState('');
  const [mockData, setMockData] = useState(null);
  const whiteListEnv = ['azureDEV', 'azureDEV2', 'DEV1', 'DEV2', 'local'];
  const hideContent = !whiteListEnv.includes(process.env.TARGET_ENV);

  useEffect(() => {
    const mock = sessionStorage.getItem('mockData');
    const init = (hideContent = false) => {
      if (!hideContent) {
        const parseText = JSON.stringify(Result.messages, null, 2);
        setMockTextArea(parseText);
        setMockData(Result.messages);
      }
    };

    try {
      const parseText = JSON.parse(mock);
      if (mock && mock !== '' && parseText) {
        if (parseText.messages) {
          const parseTextPrettier = JSON.stringify(parseText.messages, null, 2);
          setMockTextArea(parseTextPrettier);
          setMockData(parseText.messages);
        } else {
          const parseTextPrettier = JSON.stringify(parseText, null, 2);
          setMockTextArea(parseTextPrettier);
          setMockData(parseText);
        }
      } else {
        init(hideContent);
      }
    } catch (error) {
      alert('Error on the Format, It will be display the default json!');
      init(hideContent);
    }
  }, []);
  const onChange = data => {
    // console.log(data);
    const { formValues } = data;
    console.log(transformFormValues(formValues));
  };

  return (
    <React.Fragment>
      {!hideContent && (
        <div>
          <div>
            <button
              onClick={() => {
                setMockTextArea('');
              }}>
              Remove All
            </button>
            <button
              onClick={() => {
                sessionStorage.setItem('mockData', mockTextArea);
                window.location.reload();
              }}>
              Save & Reload
            </button>
            <button
              onClick={() => {
                sessionStorage.setItem('mockData', '');
                window.location.reload();
              }}>
              Reset
            </button>
          </div>
          <div className="mock-wrapper">
            <textarea
              className="mock-input"
              value={mockTextArea}
              onChange={e => {
                setMockTextArea(e.target.value);
              }}></textarea>
          </div>
        </div>
      )}
      <div className="questionnaire-page-container">
        <div className="content-parser-container">
          {mockData && (
            <ContentParser
              key={10}
              pageId={10}
              numberOfColumns={mockData.numberOfColumns || 3}
              data={mockData}
              showLabels={false}
              debug={false}
              onChange={onChange}
              readOnly={true}
              parentReadOnly={false}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/ui/features/TestParser/index.js